export default "__VITE_ASSET__Buo9Pfb2__"